module.exports = __webpack_public_path__ + "static/mobile-optimized-design-30348e9eba5aff8345c4a94faee6e1c8.webp";